import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { LightThemeProvider } from '@qflow/theme'

import { Home } from 'portal/components/Home'
import { Sidebar } from 'portal/components/Sidebar'
import { PageContainer } from 'portal/pages/PageContainer'

import { accountLoad } from 'portal/store/accountDetails/actions'
import { selectGlobalDate } from 'portal/store/global/selectors'

const globalDateSelector = selectGlobalDate()

export const HomePage = () => {
  const dispatch = useDispatch()
  const { accountId } = useParams<{ accountId: string }>()

  const { startDate, endDate } = useSelector(globalDateSelector)

  useEffect(() => {
    dispatch(accountLoad(accountId))
  }, [accountId, dispatch])

  return (
    <LightThemeProvider>
      <Sidebar />
      <PageContainer>
        <Home startDate={startDate} endDate={endDate} />
      </PageContainer>
    </LightThemeProvider>
  )
}
